import * as React from "react";
import IconSearch from "./icon/iconsearch";
import IconBuilding from "./icon/iconbuilding";
import IconGeoAlt from "./icon/icongeoalt";

interface SuggestIconProps {
    icon: string;
}

const SuggestIcon = ({ icon }: SuggestIconProps) => {
    switch (icon) {
        case "building":
            return <IconBuilding />;
        case "geoalt":
            return <IconGeoAlt />;
        default:
            return <IconBuilding />;
    }
};

export default SuggestIcon;
